import { render, staticRenderFns } from "./TestingCheck.vue?vue&type=template&id=752ae1f2"
import script from "./TestingCheck.vue?vue&type=script&lang=ts"
export * from "./TestingCheck.vue?vue&type=script&lang=ts"
import style0 from "./TestingCheck.vue?vue&type=style&index=0&id=752ae1f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports